"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleToLanguage = exports.locales = exports.defaultLocale = void 0;
exports.defaultLocale = 'en-US';
exports.locales = {
    'en-US': async () => Promise.resolve().then(() => __importStar(require('./en-US.json'))),
    'de-DE': async () => Promise.resolve().then(() => __importStar(require('./de-DE.json'))),
    'es-ES': async () => Promise.resolve().then(() => __importStar(require('./es-ES.json'))),
    'fi-FI': async () => Promise.resolve().then(() => __importStar(require('./fi-FI.json'))),
    'fr-CA': async () => Promise.resolve().then(() => __importStar(require('./fr-CA.json'))),
    'fr-FR': async () => Promise.resolve().then(() => __importStar(require('./fr-FR.json'))),
    'it-IT': async () => Promise.resolve().then(() => __importStar(require('./it-IT.json'))),
    'ja-JP': async () => Promise.resolve().then(() => __importStar(require('./ja-JP.json'))),
    'ko-KR': async () => Promise.resolve().then(() => __importStar(require('./ko-KR.json'))),
    'nl-NL': async () => Promise.resolve().then(() => __importStar(require('./nl-NL.json'))),
    'pt-BR': async () => Promise.resolve().then(() => __importStar(require('./pt-BR.json'))),
    'pt-PT': async () => Promise.resolve().then(() => __importStar(require('./pt-PT.json'))),
    'ru-RU': async () => Promise.resolve().then(() => __importStar(require('./ru-RU.json'))),
    'sv-SE': async () => Promise.resolve().then(() => __importStar(require('./sv-SE.json'))),
    'th-TH': async () => Promise.resolve().then(() => __importStar(require('./th-TH.json'))),
    'tr-TR': async () => Promise.resolve().then(() => __importStar(require('./tr-TR.json'))),
    'zh-Hans': async () => Promise.resolve().then(() => __importStar(require('./zh-Hans.json'))),
    'zh-Hant': async () => Promise.resolve().then(() => __importStar(require('./zh-Hant.json')))
};
var LocaleToLanguage;
(function (LocaleToLanguage) {
    LocaleToLanguage["en-US"] = "English";
    LocaleToLanguage["de-DE"] = "Deutsch";
    LocaleToLanguage["es-ES"] = "Espa\u00F1ol";
    LocaleToLanguage["fi-FI"] = "Suomi";
    LocaleToLanguage["fr-CA"] = "Fran\u00E7ais (Canada)";
    LocaleToLanguage["fr-FR"] = "Fran\u00E7ais";
    LocaleToLanguage["it-IT"] = "Italiano";
    LocaleToLanguage["ja-JP"] = "\u65E5\u672C\u8A9E";
    LocaleToLanguage["ko-KR"] = "\uD55C\uAD6D\uC5B4";
    LocaleToLanguage["nl-NL"] = "Nederlands";
    LocaleToLanguage["pt-BR"] = "Portugu\u00EAs (Brasil)";
    LocaleToLanguage["pt-PT"] = "Portugu\u00EAs (Portugal)";
    LocaleToLanguage["ru-RU"] = "\u0420\u0443\u0441\u0441\u043A\u0438\u0439";
    LocaleToLanguage["sv-SE"] = "Svenska";
    LocaleToLanguage["th-TH"] = "\u0E44\u0E17\u0E22";
    LocaleToLanguage["tr-TR"] = "T\u00FCrk\u00E7e";
    LocaleToLanguage["zh-Hans"] = "\u4E2D\u6587\uFF08\u7B80\u4F53)";
    LocaleToLanguage["zh-Hant"] = "\u4E2D\u6587\uFF08\u7E41\u9AD4)";
})(LocaleToLanguage = exports.LocaleToLanguage || (exports.LocaleToLanguage = {}));
exports.default = exports.locales;
